import React from 'react';
import FormObjectsTable from '@/forms/objects/components/FormObjectsTable';
import selectors from '../hooks/selectors';
import events from '../hooks/events';

const RequestObjectsTable = ({
  category,
  code,
  field,
  text = [],
}) => {
  const items = Array.isArray(text) ? text : [];
  const state = selectors.useRequestObjectsTable({
    category, code, field, items,
  });
  const showItem = events.useShowRequestObjects(category, { code });
  const deleteItem = events.useDeleteRequestObject(category, { code });
  const addItem = events.useAddRequestObject(category, { code });
  const updateProperties = events.useUpdateRequestFieldsObjectProperties(category, { code });

  return (
    <FormObjectsTable
      addItem={() => addItem({ activeFieldName: field.name, sections: state.sections })}
      allowAdd={state.allowAdd}
      allowRemove={state.allowRemove}
      canEdit={state.canEdit}
      className="aridhia-request-objects-table"
      code={code}
      deleteItem={(index) => deleteItem({ activeFieldName: field.name, activeIndex: index })}
      field={field}
      items={items}
      showItem={(index) => showItem({ activeFieldName: field.name, activeIndex: index, sections: state.sections })}
      updateProperties={(attributes) => updateProperties({ ...attributes, activeFieldName: field.name })}
    />
  );
};

export default RequestObjectsTable;
